import {
  zlbBudgetPerformFillDetailGet,
  zlbBudgetPerformFillWorkflowCancelPost,
  zlbBudgetPerformFillWorkflowSubmitPost,
  zlbBudgetPerformReportAgentDetailGet,
  zlbBudgetPerformReportAgentListGet,
  zlbBudgetPerformReportAuditDetailGet,
  zlbBudgetPerformReportDeletePost,
  zlbBudgetPerformReportManagerDetailGet,
  zlbBudgetPerformReportManagerListGet,
  zlbBudgetPerformReportSaveOrUpdatePost,
  zlbBudgetPerformReportSendAlertPost,
  zlbBudgetPerformReportWorkflowCancelPost,
  zlbBudgetPerformReportWorkflowSubmitPost,
} from '@/api/zlbBudget';
import {
  getAgentBudgetPerformChangeRecord,
  getAgentBudgetPerformReportDetail,
  getAuditBudgetPerformChangeRecord,
} from '../services';

export default {
  namespace: 'budgetPerform',
  state: {},
  effects: {
    // 经办人-查询申报单列表
    *getBudgetPerformAgentList({ payload }, { call }) {
      return yield call(zlbBudgetPerformReportAgentListGet, payload);
    },
    // 绩效管理员-查询申报单列表
    *getBudgetPerformManagerList({ payload }, { call }) {
      return yield call(zlbBudgetPerformReportManagerListGet, payload);
    },
    // 异常项目发送预警
    *sendBudgetPerformAlert({ payload }, { call }) {
      return yield call(zlbBudgetPerformReportSendAlertPost, payload);
    },
    // 绩效管理员-查询申报单详情
    *getBudgetPerformManagerDetail({ payload }, { call }) {
      return yield call(zlbBudgetPerformReportManagerDetailGet, payload);
    },
    // 审核人-查询申报单详情
    *getBudgetPerformAuditDetail({ payload }, { call }) {
      return yield call(zlbBudgetPerformReportAuditDetailGet, payload);
    },
    // 经办人-查询申报单详情
    *getBudgetPerformAgentDetail({ payload }, { call }) {
      return yield call(zlbBudgetPerformReportAgentDetailGet, payload);
    },
    // 申报单删除
    *deleteBudgetPerform({ payload }, { call }) {
      return yield call(zlbBudgetPerformReportDeletePost, payload);
    },
    // 预算申报单保存更新
    *saveBudgetPerform({ payload }, { call }) {
      return yield call(zlbBudgetPerformReportSaveOrUpdatePost, payload);
    },
    // 提交申报
    *submitBudgetPerform({ payload }, { call }) {
      return yield call(zlbBudgetPerformReportWorkflowSubmitPost, payload);
    },
    // 撤回申报
    *revokeReport({ payload }, { call }) {
      return yield call(zlbBudgetPerformReportWorkflowCancelPost, payload);
    },
    // 撤回填报
    *revokeFill({ payload }, { call }) {
      return yield call(zlbBudgetPerformFillWorkflowCancelPost, payload);
    },
    // 填报单详情
    *getFillDetail({ payload }, { call }) {
      return yield call(zlbBudgetPerformFillDetailGet, payload);
    },
    // 提交填报
    *submitFillPerform({ payload }, { call }) {
      return yield call(zlbBudgetPerformFillWorkflowSubmitPost, payload);
    },
    // 经办人-查询申报单详情（绩效变更入口查询接口）
    *getAgentBudgetPerformReportDetail({ payload }, { call }) {
      return yield call(getAgentBudgetPerformReportDetail, payload);
    },
    // 经办人-查询绩效变更记录（最新一条绩效变更申请单详情）
    *getAgentBudgetPerformChangeRecord({ payload }, { call }) {
      return yield call(getAgentBudgetPerformChangeRecord, payload);
    },
    // 审批人-查询绩效变更详情
    *getAuditBudgetPerformChangeRecord({ payload }, { call }) {
      return yield call(getAuditBudgetPerformChangeRecord, payload);
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
